// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseRow{display:-webkit-box;display:-ms-flexbox;display:flex;flex-wrap:wrap;position:relative;}@media (max-width: 799px){.BaseRow .BaseColumn:not(:last-of-type){margin-bottom:40px}}.is-dr3-theme .BaseRow,.is-ln4-theme .BaseRow,.is-orange-dark-theme .BaseRow{color:#FFFFFF}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
